import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd  } from '@angular/router';
import { NgForm, FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { WpService} from '../../../wp.service';
import emailjs, { EmailJSResponseStatus } from 'emailjs-com';
import{ init } from 'emailjs-com';
init("user_Ffw6WrrZGHUfdlmIAkjcD");

@Component({
  selector: 'app-formulario-elecciones',
  templateUrl: './formulario-elecciones.component.html',
  styleUrls: ['./formulario-elecciones.component.scss'],
  providers:[WpService]
})
export class FormularioEleccionesComponent implements OnInit {

/*npm audit*/
  ngOnInit(): void {
  }

  @ViewChild('formident',{static: true})formident: NgForm;  
  
  
  
  apellido: any;
  nombre: any;
  correo: any;
  afiliado: any;  
  claustro: any; 
  userID: any;
  serviceID: any;
  templateParams: any;
  templateID: any;
  
  public inscripto: any;
  
  fragment: any;
  
    constructor(private router: Router, private route: ActivatedRoute, private wpService: WpService, private http:HttpClient ){
      
      
      this.nombre = {};
      this.correo = {};
      this.afiliado = {};
      this.apellido = {};       
      this.claustro = {};       
      
    }
   
    
     
    
    
    submit(){
      this.apellido = this.formident.value.apellido;
      this.nombre = this.formident.value.nombre;
      this.correo = this.formident.value.correo;
      this.afiliado = this.formident.value.afiliado;            
      this.claustro = this.formident.value.claustro;            
      let apellido = JSON.stringify(this.apellido);
      let nombre = JSON.stringify(this.nombre);
      let correo = JSON.stringify(this.correo);
      let afiliado = JSON.stringify(this.afiliado);      
      let claustro = JSON.stringify(this.claustro);      

      this.inscripto = [{
        "apellido" : apellido,
        "nombre" : nombre,
        "correo" : correo,
        "afiliado" : afiliado,       
        "claustro" : claustro
      }];
      /*let userID = 'user_Ffw6WrrZGHUfdlmIAkjcD';
      let serviceID = 'service_6579hx8';
      let templateID = 'template_asamblea';
      let templateParams = [{
        'nombre' : nombre,
        'apellido' : apellido,        
        'correo' : correo,
        'afiliado' : afiliado,       
        'claustro' : claustro
      }];*/
      this.wpService.insertarDatosElecciones(this.inscripto).subscribe(()=>
    {      
      alert('Inscripción realizada con éxito');
    })
    this.formident.reset();
      emailjs.send("service_6579hx8","template_asamblea",{
        "nombre": this.nombre,
        "apellido": this.apellido,
        "correo": this.correo,
        "afiliado": this.afiliado,
        "claustro": this.claustro,
        }).then(function(response) {
          console.log('SUCCESS!', response.status, response.text);          
       }, function(error) {
          console.log('FAILED...', error);          
       });
       
    /*
      emailjs.send(serviceID, templateID, templateParams, userID).then(function(response) {
       console.log('SUCCESS!', response.status, response.text);
    }, function(error) {
       console.log('FAILED...', error);
    });
    /*this.wpService.insertarDatosElecciones(this.inscripto).subscribe(()=>
    {      
      alert('Inscripción realizada con éxito');
    })
    this.formident.reset();*/
    
    }  
 

}
